import { Button } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import { TableProducts } from '@hero/components/organisms/TableProducts';
import { ReviewSection } from '@hero/molecules';
import { useGetRecognitionProducts } from '@hero/services';
import { useNotification } from '@hero/store/hooks';
import { hasAnyAvailableProducts } from '@hero/utils';

import * as S from './style';

export function GiftCollectionSection({
  recognitionCode,
  stepIndex = 1,
  isCompleted = true,
  products = [],
  onEdit = () => {}
}) {
  const { t } = useTranslation();
  const { showNotification } = useNotification();

  useGetRecognitionProducts(recognitionCode, {
    enabled: !!recognitionCode,
    onSuccess: data => {
      if (!hasAnyAvailableProducts(data)) {
        showNotification({
          title: (
            <Trans
              key="noAvailableProducts"
              i18nKey="noAvailableProducts"
              values={{ feature: t('oneTimeGift').toLocaleLowerCase() }}
            />
          ),
          message: (
            <Trans
              key="noAvailableProductsDesc"
              i18nKey="noAvailableProductsDesc"
              values={{ feature: t('oneTimeGift').toLocaleLowerCase() }}
            />
          ),
          primaryButtonProps: { children: t('editGiftCollection') },
          onSubmit: () => {
            onEdit();
          }
        });
      }
    }
  });

  return (
    <ReviewSection
      id="section-gift-collection"
      stepIndex={stepIndex}
      isCompleted={isCompleted}
      title={t('giftCollection')}
      subTitle={t('giftCollectionDescription')}
      headerChildren={
        <Button size="sm" variant="outlined" onClick={onEdit}>
          {t('editCollection')}
        </Button>
      }
    >
      <S.GCBodyContent>
        {!!products.length && (
          <TableProducts
            products={products}
            maxVisibleProducts={6}
            imageSize={{ width: 80, height: 88 }}
          />
        )}
      </S.GCBodyContent>
    </ReviewSection>
  );
}

GiftCollectionSection.propTypes = {
  stepIndex: PropTypes.number,
  isCompleted: PropTypes.bool,
  products: PropTypes.array,
  onEdit: PropTypes.func
};
